// Module
var code = " <template aria-hidden=\"true\"><require from=\"./md-icon.scss\"></require>${name}</template> ";
// Exports
module.exports = code;